var _mask, _path, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProgress5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_381_484",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0C12.0689 2.46718e-08 14.0869 0.641717 15.7759 1.8367C17.4648 3.03169 18.7415 4.72111 19.43 6.67212C20.1185 8.62312 20.185 10.7397 19.6201 12.73C19.0553 14.7203 17.8871 16.4865 16.2764 17.785L10 10L10 0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C12.0689 2.46718e-08 14.0869 0.641717 15.7759 1.8367C17.4648 3.03169 18.7415 4.72111 19.43 6.67212C20.1185 8.62312 20.185 10.7397 19.6201 12.73C19.0553 14.7203 17.8871 16.4865 16.2764 17.785L10 10L10 0Z",
    fill: "#09702B",
    stroke: "#09702B",
    strokeWidth: 4,
    mask: "url(#path-1-inside-1_381_484)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9,
    transform: "rotate(-90 10 10)",
    stroke: "#09702B",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgress5);
export default __webpack_public_path__ + "static/media/progress5.86225ab352e503646859b0173049a9f7.svg";
export { ForwardRef as ReactComponent };